import React, { useMemo } from 'react';
import { useAppDispatch, useAuthState, useModalState } from '@core/configureStore';
import { closeModal } from '@core/features';
import { Divider, Modal } from 'antd';
import { ReservationFormContainer } from '..';
import { fetchReservations } from '@core/features/booking/thunks/fetchReservations.thunk';
import { Reservation } from '@core/models';

const ReservationDetailModal = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuthState();
  const { reservationDetailModal, extraParams } = useModalState();
  const existingReservation = useMemo<Reservation<any>>(
    () => extraParams?.existingReservation,
    [extraParams]
  );

  const handleModalClose = () => {
    dispatch(
      closeModal({
        modalName: 'reservationDetailModal',
      })
    );
  };

  const handleOk = () => {
    handleModalClose();
  };

  return (
    <Modal
      title={'Reservation'}
      open={reservationDetailModal}
      onOk={handleOk}
      onCancel={handleModalClose}
      footer={[]}
      closable>
      <Divider />
      <ReservationFormContainer
        existingReservation={existingReservation}
        propsLocationId={user?.selected_location?.location_id}
        onUpdated={async () => {
          await dispatch(fetchReservations());
          handleModalClose();
        }}
      />
    </Modal>
  );
};

export default ReservationDetailModal;
